import { OPAQUE_CONFIG } from '../../config';
import moment from 'moment-timezone';

const opaqueLocation = {
  appointmentInterval: OPAQUE_CONFIG.appointmentInterval,
  appointmentSlots: OPAQUE_CONFIG.appointmentSlots,
  defaultImage: '/images/concierge_overlay_image.jpg',
  distanceFromCurrentLocation: null,
  hours: OPAQUE_CONFIG.hours,
  id: null,
  isFormatted: true,
  isOpaque: true,
  isSolvPartner: false,
  name: 'TBD',
  timeZone: 'America/Los_Angeles',
};

const generateOpaqueSlots = () => {
  const dayNameFormat = 'dddd';
  const slotDuration = opaqueLocation.appointmentInterval;

  const setTime = (datetime, time) => {
    const timeParts = time.split(':');
    return datetime
      .hours(timeParts[0])
      .minutes(timeParts[1])
      .seconds(timeParts[2])
      .milliseconds(0);
  };

  const today = [];
  let dayName = moment()
    .tz(opaqueLocation.timeZone)
    .format(dayNameFormat);
  if (dayName in opaqueLocation.hours) {
    const todaysHours = opaqueLocation.hours[dayName];

    for (const openClosePair of todaysHours) {
      const start = setTime(moment.tz(opaqueLocation.timeZone), openClosePair.fromTime);
      const finish = setTime(moment.tz(opaqueLocation.timeZone), openClosePair.toTime);
      for (let slot = start; slot.isSameOrBefore(finish); slot.add(slotDuration, 'minutes')) {
        today.push({
          appointmentDate: slot.valueOf(),
          availability: opaqueLocation.appointmentSlots,
        });
      }
    }
  }

  const tomorrow = [];
  dayName = moment()
    .tz(opaqueLocation.timeZone)
    .add(1, 'day')
    .format(dayNameFormat);
  if (dayName in opaqueLocation.hours) {
    const tomorrowsHours = opaqueLocation.hours[dayName];

    for (const openClosePair of tomorrowsHours) {
      const start = setTime(moment.tz(opaqueLocation.timeZone), openClosePair.fromTime).add(
        1,
        'day'
      );
      const finish = setTime(moment.tz(opaqueLocation.timeZone), openClosePair.toTime).add(
        1,
        'day'
      );
      for (let slot = start; slot.isSameOrBefore(finish); slot.add(slotDuration, 'minutes')) {
        tomorrow.push({
          appointmentDate: slot.valueOf(),
          availability: opaqueLocation.appointmentSlots,
        });
      }
    }
  }

  return today.concat(tomorrow);
};

opaqueLocation.slots = generateOpaqueSlots();

export { opaqueLocation };
